// extracted by mini-css-extract-plugin
export default {"TabList":"TabList__TabList___Igdz0","tabItem":"TabList__tabItem___xl67r","active":"TabList__active___wxbCP"};